import React from 'react';
import { Empty, Tabs } from 'antd';
import PageTitle from '@/components/PageTitle';
import { checkPermission } from '@/utils/permission';
import CommissionReconciliationPage from './CommissionReconciliationPage';
import CommissionApprovalPage from './CommissionApprovalPage';
import CommissionPeriodPage from './CommissionPeriodPage';
import CommissionHoldPage from './CommissionHoldPage';
import CommissionAdjustmentPage from './CommissionAdjustmentPage';
import { CommissionCustomerServiceDetailProvider } from './CommissionCustomerServiceColumns';
import useCommissionTabs from './useCommissionTabs';

const { TabPane } = Tabs;

export default function CommissionControlPage() {
    const tabs = [
        { key: 'reconciliation', label: 'Kiểm tra số liệu', allowed: checkPermission('commission_reconciliation', 'view'), content: <CommissionReconciliationPage embedded /> },
        { key: 'approval', label: 'Duyệt hoa hồng', allowed: checkPermission('commission_approval', 'view'), content: <CommissionApprovalPage embedded /> },
        { key: 'period', label: 'Chốt kỳ', allowed: checkPermission('commission_period', 'view'), content: <CommissionPeriodPage embedded /> },
        { key: 'exceptions', label: 'Khoản chờ xử lý', allowed: checkPermission('commission_hold', 'view'), content: <CommissionHoldPage embedded /> },
        { key: 'adjustments', label: 'Điều chỉnh & công nợ', allowed: checkPermission('commission_adjustment', 'view'), content: <CommissionAdjustmentPage embedded /> },
    ].filter(tab => tab.allowed);
    const { activeTabKey, onTabChange } = useCommissionTabs(tabs);
    return <CommissionCustomerServiceDetailProvider>
        <div>
            <PageTitle routes={[{ path: '/', breadcrumbName: 'Trang chủ' }, { path: '#', breadcrumbName: 'Kiểm soát hoa hồng' }]} title="Kiểm soát hoa hồng" />
            {tabs.length ? <Tabs activeKey={activeTabKey} onChange={onTabChange} destroyInactiveTabPane>{tabs.map(tab => <TabPane tab={tab.label} key={tab.key}>{tab.content}</TabPane>)}</Tabs> : <Empty description="Bạn chưa có quyền xem các chức năng kiểm soát." />}
        </div>
    </CommissionCustomerServiceDetailProvider>;
}
